import cartModel from "./cartModel";
import cartTemplate from "./cartTemplate";

const cartDrawer = (() => {
  const SELECTOR_CLOSE = ".js-cartClose";
  const SELECTOR_TOGGLE = ".js-cartToggle";
  const SELECTOR_CONTAINER = ".js-cartContainer";

  const state = {
    open: false,
    view: null,
  };

  function onStateChange() {
    let action = "add";
    if (!state.open) {
      action = "remove";
    }

    document.documentElement.classList[action]("state--cart-drawer-open");
  }

  function open() {
    state.open = true;
    onStateChange();

    setTimeout(() => close(), 5000);
  }

  function close() {
    state.open = false;
    onStateChange();
  }

  function onToggleClick(ev) {
    ev.preventDefault();
    state.open = !state.open;

    onStateChange();
  }

  function onCloseClick(ev) {
    ev.preventDefault();
    close();
  }

  function bind() {
    Array.prototype.forEach.call(
      document.querySelectorAll(SELECTOR_TOGGLE),
      (el) => {
        el.removeEventListener("click", onToggleClick);
        el.addEventListener("click", onToggleClick);
      }
    );
    Array.prototype.forEach.call(
      document.querySelectorAll(SELECTOR_CLOSE),
      (el) => {
        el.removeEventListener("click", onCloseClick);
        el.addEventListener("click", onCloseClick);
      }
    );
  }

  function render(data = {}) {
    state.view.innerHTML = cartTemplate(data);
    bind();
  }

  function init() {
    state.view = document.createElement("div");
    state.view.classList.add("cart-drawer__container");
    document.querySelector(SELECTOR_CONTAINER).appendChild(state.view);
    cartModel.addCallback(render);
  }

  return {
    close,
    init,
    open,
  };
})();

export default cartDrawer;
